var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrepTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_242_5103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.78326 1.32697H6.69674",
    stroke: "#3E3E3E",
    strokeWidth: 0.861066,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.74096 11.3249C8.09231 11.3249 9.99846 9.41879 9.99846 7.06744C9.99846 4.71609 8.09231 2.80995 5.74096 2.80995C3.38961 2.80995 1.48347 4.71609 1.48347 7.06744C1.48347 9.41879 3.38961 11.3249 5.74096 11.3249Z",
    stroke: "#3E3E3E",
    strokeWidth: 0.861066,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 731",
    d: "M2.88883 8.18674C3.10436 8.70191 3.45542 9.14907 3.90472 9.4807C4.35402 9.81233 4.88476 10.0161 5.44056 10.0702C5.99637 10.1244 6.55646 10.027 7.06133 9.7883C7.5662 9.54965 7.99698 9.17868 8.30791 8.71481C8.61884 8.25095 8.7983 7.71152 8.82721 7.15383C8.85613 6.59615 8.73342 6.04105 8.47214 5.54751C8.21085 5.05398 7.82074 4.64045 7.34326 4.35086C6.86578 4.06127 6.31876 3.90645 5.76034 3.90284L5.74035 6.99378L2.88883 8.18674Z",
    fill: "#0C995E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_242_5103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.4809,
    height: 11.4809,
    fill: "white",
    transform: "translate(0 0.370239)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrepTimeIcon);
export default __webpack_public_path__ + "static/media/PrepTimeIcon.9a5639d73d2a7b107cb6cc78de08b67e.svg";
export { ForwardRef as ReactComponent };